import {Component, forwardRef} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { GedModel } from '../ged.model';
import { DocumentScannerModel } from '../../document-scanner/document-scanner.model';
import { CODE_WORKFLOW_COMPONENT } from 'src/app/app.models';

@Component({
    selector: 'abw-ged-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => GedFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => GedFormComponent),
        multi: true
      }
    ],
    templateUrl: './ged-form.component.html',
    styleUrls: ['./ged-form.component.scss']
})
export class GedFormComponent extends AbstractWorkflowFormComponent<GedModel, string> {
  documentScannerModel = DocumentScannerModel.initModel({
    ID: 'GED_DOCUMENT_SCANNER',
    CODE: CODE_WORKFLOW_COMPONENT.SCAN_DOCUMENT,
    LABEL: 'Scanner un document',
  });
}